module.exports = __webpack_public_path__ + "img/TAB_03_Active.523ef748.svg";